import { ReactRenderer } from '@tiptap/react';
import tippy, { Instance as TippyInstance } from 'tippy.js';
import { MentionList } from './MentionList';
import { searchUsers, SearchUser } from '@/api/community';

export const mentionSuggestion = {
  items: async ({ query }: { query: string }): Promise<SearchUser[]> => {
    if (!query || query.length < 1) {
      return [];
    }

    try {
      const results = await searchUsers(query);
      return results.slice(0, 5); // Limit to 5 results
    } catch (error) {
      console.error('Error searching users for mentions:', error);
      return [];
    }
  },

  // Customize how mentions are rendered in the editor
  renderLabel({ node }: { node: any }) {
    return `@${node.attrs.label ?? node.attrs.id}`;
  },

  render: () => {
    let component: ReactRenderer<any>;
    let popup: TippyInstance[];

    return {
      onStart: (props: any) => {
        component = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect as () => DOMRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
          maxWidth: 'none',
          theme: 'mention-popup',
        });
      },

      onUpdate(props: any) {
        component.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect as () => DOMRect,
        });
      },

      onKeyDown(props: any) {
        if (props.event.key === 'Escape') {
          popup[0].hide();
          return true;
        }

        return (component.ref as any)?.onKeyDown(props);
      },

      onExit() {
        if (popup && popup[0]) {
          popup[0].destroy();
        }
        if (component) {
          component.destroy();
        }
      },
    };
  },
};
